import React, { ReactNode } from 'react';
import Tooltip, { Overlay, Placement, TooltipProps } from '../Tooltip';
import classNames from 'classnames';
import styles from './KeyboardShortcut.module.scss';

export function Key(props) {
  return (
    <span className={classNames(styles.key, props.className, 'shortcut-key')}>
      {props.children}
    </span>
  );
}

export function KeyWithTrigger({
  trigger = 'g',
  keyChar,
  className,
}: {
  trigger?: string;
  keyChar: string;
  className?: string;
}) {
  return (
    <span className={classNames(className, 'text-small text-default')}>
      <Key>{trigger}</Key>
      <span>&nbsp;then&nbsp;</span>
      <Key>{keyChar}</Key>
    </span>
  );
}

interface OverlayProps {
  placement?: Placement;
  shortcut?: ReactNode;
  keys?: Array<string> | string;
  label?: string;
  hideTooltip?: boolean;
}

function ShortcutOverlay({ placement = null, shortcut = null, keys = '', label }: OverlayProps) {
  if (shortcut === null) {
    if (!Array.isArray(keys)) {
      keys = keys.split('');
    }

    shortcut = (
      <>
        {keys.map((key, i) => (
          <Key key={i}>{key}</Key>
        ))}
      </>
    );
  }

  return (
    <Overlay placement={placement}>
      {shortcut}
      {label ? ' ' + label : ''}
    </Overlay>
  );
}

export default function KeyboardShortcut({
  children = null,
  placement = 'right',
  shortcut = null,
  keys = '',
  label = null,
  hideTooltip = false,
  ...props
}: TooltipProps & OverlayProps) {
  return (
    <Tooltip
      popupClassName={classNames(
        styles.container,
        props.className,
        hideTooltip && styles.hideTooltip,
      )}
      delay
      placement={placement}
      overlay={
        <ShortcutOverlay placement={placement} keys={keys} shortcut={shortcut} label={label} />
      }
      {...props}
    >
      {children}
    </Tooltip>
  );
}

KeyboardShortcut.Key = Key;
